import React, { useState } from "react";
import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { useNavigate } from "react-router-dom";
import { NavModel } from "../Models/NavModel";
import { FooterModel } from "../Models/FooterModel";
import Utils from "../Utils/Utils";

import "./Nav.css";

const Nav: React.FC<{
  blok: NavModel;
  smallHeader: boolean;
  footer?: Array<FooterModel>;
}> = ({ blok, smallHeader, footer }) => {
  const types = ["default", "footer", "iconButton", "lastButton"];
  let [openMobile, setOpenMobile] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setOpenMobile(!openMobile);
  };

  const handleLogoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(`/`);
    if (openMobile === true) {
      setOpenMobile(!openMobile);
    }
  };

  return (
    <div
      className={`navbar ${smallHeader ? "small" : ""}`}
      {...storyblokEditable(blok)}
    >
      <div className="container">
        <div className="navbar-logo">
          <a href="/" onClick={handleLogoClick}>
            {!smallHeader && (
              <img
                src={Utils.getCacheUrl(blok.logo?.filename)}
                alt=""
                onError={(e) => Utils.handleImageError(e, blok.logo?.filename)}
              />
            )}
            {smallHeader && (
              <img
                src={Utils.getCacheUrl(blok.smallLogo?.filename)}
                alt=""
                onError={(e) =>
                  Utils.handleImageError(e, blok.smallLogo.filename)
                }
              />
            )}
          </a>
        </div>
        <ul className={`navbar-links ${openMobile ? "open-mobile" : ""}`}>
          {types.map((type) => (
            <div className={`navbar-link-${type}`} key={`navbar-link-${type}`}>
              {type === "footer" && footer && footer.length > 0
                ? footer[0].topHyperlinks.map((hyperlink) => (
                    <li key={`li-${hyperlink._uid}`}>
                      <div className={`nav-link default`}>
                        <StoryblokComponent
                          blok={hyperlink}
                          key={hyperlink._uid}
                          onButtonClick={() => setOpenMobile(false)}
                        />
                      </div>
                    </li>
                  ))
                : null}
              {blok.buttons && type !== "footer"
                ? blok.buttons
                    .filter((button) => button.type === type)
                    .map((button) => (
                      <li key={`li-${button._uid}`}>
                        <div
                          className={`nav-link ${
                            button.navDropdown?.length > 0 &&
                            button.type !== types[2]
                              ? "arrow"
                              : ""
                          } ${button.type}`}
                        >
                          <StoryblokComponent
                            blok={button}
                            key={button._uid}
                            onClick={() => setOpenMobile(false)}
                          />
                        </div>
                      </li>
                    ))
                : null}
            </div>
          ))}
        </ul>
      </div>
      <span className="nav-mobile-button" onClick={handleClick}>
        {openMobile && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            className="am-e-SVG"
          >
            <path d="M32 2.8 29.2 0 16 13.2 2.8 0 0 2.8 13.2 16 0 29.2 2.8 32 16 18.8 29.2 32l2.8-2.8L18.8 16 32 2.8Z"></path>
          </svg>
        )}
        {!openMobile && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            className="am-e-SVG"
          >
            <path d="M.25 0h17.5v2H.25V0Z M.25 8h17.5v2H.25V8Z M.25 16h17.5v2H.25V16Z"></path>
          </svg>
        )}
      </span>
    </div>
  );
};

export default Nav;
